import { experience, images } from "../content/site";
import { FadeUp, StaggerGroup, StaggerItem } from "./Reveal";

export default function LoungeExperience() {
  return (
    <section
      id="experience"
      data-testid="section-experience"
      className="relative bg-navy py-28 text-cream sm:py-36"
    >
      <div className="container-edge">
        <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
          <div className="lg:col-span-8">
            <FadeUp delay={0.05}>
              <h2 className="max-w-3xl font-serif text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                {experience.headline}
              </h2>
            </FadeUp>
          </div>
          <div className="lg:col-span-4">
            <FadeUp delay={0.1}>
              <p className="font-sans text-base font-light leading-relaxed text-cream/70">
                {experience.intro}
              </p>
            </FadeUp>
          </div>
        </div>

        {/* Numbered manifesto chapters */}
        <StaggerGroup className="mt-20 grid gap-px border-t border-cream/12 sm:grid-cols-2 lg:grid-cols-3">
          {experience.chapters.map((c) => (
            <StaggerItem
              key={c.no}
              className="group border-b border-cream/12 bg-navy py-10 transition-colors duration-500 hover:bg-navy-800 sm:px-8"
            >
              <div className="flex items-baseline gap-4">
                <span className="font-serif text-2xl text-brass">{c.no}</span>
                <span className="h-px flex-1 bg-cream/15 transition-colors duration-500 group-hover:bg-brass/50" />
              </div>
              <h3 className="mt-6 font-serif text-2xl tracking-tight text-cream">{c.title}</h3>
              <p className="mt-4 font-sans text-sm font-light leading-relaxed text-cream/60">{c.copy}</p>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>

      {/* Wide atmospheric strip */}
      <FadeUp y={50} className="mt-24">
        <div className="relative h-[45vh] overflow-hidden sm:h-[60vh]">
          <img
            src={images.experienceWide}
            alt="Wide view of the Laundry Lounge floor"
            loading="lazy"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/20 to-transparent" />
        </div>
      </FadeUp>
    </section>
  );
}
